import { HERO, SUBURBS, HERO_IMAGE } from "@/lib/content";
import Reveal from "@/components/landing/Reveal";

export default function Hero() {
    return (
        <section
            id="top"
            data-testid="hero-section"
            className="relative pt-40 md:pt-48 pb-24 md:pb-40 overflow-hidden"
        >
            {/* soft pearl canvas with grain */}
            <div className="grain" aria-hidden="true" />

            <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
                {/* copy */}
                <div className="lg:col-span-7 relative z-10">
                    <Reveal>
                        <div className="flex items-center gap-4 mb-10">
                            <span className="divider-line text-cacao/40" />
                            <span className="eyebrow text-cacao/70" data-testid="hero-eyebrow">
                                {HERO.eyebrow}
                            </span>
                        </div>
                    </Reveal>

                    <Reveal delay={150}>
                        <h1
                            data-testid="hero-headline"
                            className="font-serif text-cacao text-[3.2rem] sm:text-[4.4rem] lg:text-[6.4rem] leading-[0.98] tracking-[-0.01em]"
                        >
                            We design the
                            <br />
                            feeling of <em className="italic font-light text-clay-deep">you.</em>
                        </h1>
                    </Reveal>

                    <Reveal delay={350}>
                        <p
                            data-testid="hero-subhead"
                            className="mt-10 max-w-[34rem] text-cacao/80 text-[1.02rem] md:text-[1.1rem] leading-[1.75] font-light"
                        >
                            {HERO.subhead}
                        </p>
                    </Reveal>

                    <Reveal delay={550}>
                        <div className="mt-12 flex flex-col sm:flex-row sm:items-center gap-6 sm:gap-10">
                            <a
                                href="#offer"
                                data-testid="hero-cta"
                                className="btn-clay whitespace-nowrap self-start"
                            >
                                {HERO.cta}
                            </a>
                            <p className="text-cacao/60 text-sm italic font-serif max-w-[22rem] leading-relaxed whitespace-pre-line">
                                {HERO.supporting}
                            </p>
                        </div>
                    </Reveal>

                    <Reveal delay={750}>
                        <p className="mt-16 text-cacao/55 text-[0.7rem] tracking-[0.28em] uppercase">
                            Servicing — {SUBURBS}
                        </p>
                    </Reveal>
                </div>

                {/* feature image */}
                <Reveal delay={250} className="lg:col-span-5 relative">
                    <div className="relative aspect-[4/5] w-full overflow-hidden">
                        <img
                            src={HERO_IMAGE}
                            alt="Quiet, tactile materiality — soft daylight on raw linen"
                            className="w-full h-full object-cover"
                            data-testid="hero-image"
                            loading="eager"
                        />
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
